import Actions          from "../../../model/constant/actions"
import ReducerUtils     from "../../../utils/ReducerUtils"

const initiateData = (state,action) => {
  return action.data
}
export const AdWordsPlaces = ReducerUtils.createReducer<any[]>([],{
  [Actions.RETRIEVE_ADWORDS_PLACES] : initiateData
})
